const SideBarTypes = {
    INIT: 'SIDEBAR.INIT',
    REQUESTING: 'SIDEBAR.REQUESTING',
    SUCCESS: 'SIDEBAR.SUCCESS',
    ERROR: 'SIDEBAR.ERROR',
    REQUEST_API: '/api/v1/users/get_menu_of_user'
}

export default SideBarTypes;


// WEBPACK FOOTER //
// ./src/components/Sidebar/constants.js